import {styled, Typography} from '@mui/material';

const Wrapper = styled('div')`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
	flex-direction: column;
`;

const CameraFrame = styled('div')`
	position: relative;
	width: 20rem;
	height: 24rem;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const OverlaySvg = styled('svg')`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	pointer-events: none;
`;

const FaceEllipse = styled('ellipse')<{detected: boolean}>`
	fill: none;
	stroke-width: 4;
	stroke: ${({detected, theme}) => (detected ? '#22BA74' : theme.palette.primary.main)};
	transition: all 0.3s ease;
`;

const VideoStyled = styled('video')`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	border-radius: 9999px;
	clip-path: ellipse(35.7% 40.2% at 50% 50%);
	transform: scaleX(-1);
`;

const HintText = styled(Typography)`
	text-align: center;
	z-index: 10;
	pointer-events: none;
	margin-top: -16px;
`;

const StyledImage = styled('img')`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	object-fit: cover;
	clip-path: ellipse(116.5px 155.5px at center);
	transform: scaleX(-1);
`;

export {Wrapper, CameraFrame, OverlaySvg, FaceEllipse, VideoStyled, HintText, StyledImage};
